import { Has, defineEnterSystem, getComponentValueStrict, setComponent } from "@latticexyz/recs";
import { AnalyticsLayer } from "../types";

export function createUnitBuySystem(layer: AnalyticsLayer) {
  const {
    world,
    networkLayer: {
      utils: { getOwningPlayer, getTurnAtTime },
      network: {
        components: { UnitType, OwnedBy, Position, Match },
        clock,
      },
    },
    utils: { getCurrentBlockNumber, storePlayerTotalUnitSnapshot },
    components: { UnitBuy },
  } = layer;

  defineEnterSystem(world, [Has(UnitType), Has(OwnedBy), Has(Position)], ({ entity }) => {
    const unitType = getComponentValueStrict(UnitType, entity).value;
    const player = getOwningPlayer(entity);
    if (!player) return;
    const position = getComponentValueStrict(Position, entity);
    const match = getComponentValueStrict(Match, player).value;
    const turn = getTurnAtTime(match, clock.currentTime / 1000);

    setComponent(UnitBuy, entity, {
      turn,
      createdAtBlock: getCurrentBlockNumber(),
      match,
      player,
      unitType,
      x: position.x,
      y: position.y,
    });

    storePlayerTotalUnitSnapshot(player);
  });
}
